export enum TableType {
  COMPANIES = "Selskaper",
  SAVINGSPROFILES = "Spareprofiler",
}

export const TablePath: { [key in TableType]: string } = {
  [TableType.COMPANIES]: "/selskaper",
  [TableType.SAVINGSPROFILES]: "/spareprofiler",
};

const tableTypeByPath = Object.entries(TablePath).reduce(
  (accumulator: Record<string, TableType>, [tableType, tablePath]) => {
    accumulator[tablePath] = tableType as TableType;
    return accumulator;
  },
  {},
);

export function getTableType(path: string) {
  return tableTypeByPath[`/${path}`];
}
